import { Service } from '@toeverything/infra';

import { resolveServerUrl } from './fetch';
import type { ServerService } from './server';

export class EventSourceService extends Service {
  constructor(private readonly serverService: ServerService) {
    super();
  }

  eventSource = (url: string, eventSourceInitDict?: EventSourceInit) => {
    // Resolve relative to the base URL so a subpath deployment is preserved.
    return new EventSource(
      resolveServerUrl(url, this.serverService.server.baseUrl),
      eventSourceInitDict
    );
  };
}
